import React, {PureComponent} from "react"
import Icon from "@irati/ui/src/Icon"
import {WhoRewardedRewardTypes} from "@irati/reward/enums/WhoRewardedTypes"

interface DisplayIconProps {
  rewardType: WhoRewardedRewardTypes
}

class DisplayIcon extends PureComponent<DisplayIconProps> {
  render() {
    const {rewardType} = this.props
    switch (rewardType) {
      case WhoRewardedRewardTypes.CUSTOM_NEW_REWARD: case WhoRewardedRewardTypes.CUSTOM_OLD_REWARD:
        return <Icon icon="customReward" />
      case WhoRewardedRewardTypes.CREDIT_REWARD:
        return <Icon icon="wallet" />
      default: return <Icon icon="reward" />
    }
  }
}

export default DisplayIcon
